import apiClient from "../clients/apiClient";
import { ApiResponse } from "../schemas/apiResponseSchema";
import { Schemas } from "../types/api-types";

export type UserWithActiveStatusResponse = Schemas['UserWithActiveStatusResponse'];
export type CreateUserRequest = Schemas['UserCreateRequest'];

export const getAllUsers = async (): Promise<UserWithActiveStatusResponse[]> => {
    try {
        const response: ApiResponse<UserWithActiveStatusResponse[]> = (await apiClient.get('/users/all')).data;
        return response.data;
    }
    catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.detail || 'Fetching users failed');
        }
        throw new Error('network error, please contact support team');
    }
}

export const createUser = async (userData: CreateUserRequest): Promise<any> => {
    try {
        const response: ApiResponse<any> = (await apiClient.post('/users/create', userData)).data;
        return response.data;
    }
    catch (error: any) {
        if (error.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }
        if (error.response?.data?.errors) {
            throw error.response.data.errors;
        }
        throw new Error('Failed to create user');
    }
}

export const updateUser = async (userId: number, userData: CreateUserRequest): Promise<any> => {
    try {
        const response: ApiResponse<any> = (await apiClient.put(`/users/update/${userId}`, userData)).data;
        return response.data;
    }
    catch (error: any) {
        if (error.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }
        if (error.response?.data?.errors) {
            throw error.response.data.errors;
        }
        throw new Error('Failed to update user');
    }
}

export const getUserPermissions = async (userId: number): Promise<number[]> => {
    try {
        const response: ApiResponse<number[]> = (await apiClient.get(`/users/${userId}/permissions`)).data;
        return response.data;
    }
    catch (error: any) {
        if (error.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }
        throw new Error('Failed to fetch user permissions');
    }
}

export const getUserMenus = async (userId: number): Promise<number[]> => {
    try {
        const response: ApiResponse<number[]> = (await apiClient.get(`/users/${userId}/menus`)).data;
        return response.data;
    }
    catch (error: any) {
        if (error.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }
        throw new Error('Failed to fetch user menus');
    }
}

export const deactivateUser = async (userId: number): Promise<any> => {
    try {
        const response: ApiResponse<any> = (await apiClient.post(`/users/${userId}/deactivate`)).data;
        return response.data;
    }
    catch (error: any) {
        if (error.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }
        throw new Error('Failed to deactivate user');
    }
}

export const activateUser = async (userId: number): Promise<any> => {
    try {
        const response: ApiResponse<any> = (await apiClient.post(`/users/${userId}/activate`)).data;
        return response.data;
    }
    catch (error: any) {
        if (error.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }
        throw new Error('Failed to activate user');
    }
}

export const resetUserPassword = async (userId: number): Promise<string> => {
    try {
        const response: ApiResponse<string> = (await apiClient.post(`/users/${userId}/reset_password`)).data;
        return response.data;
    }
    catch (error: any) {
        if (error.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }
        throw new Error('Failed to reset user password');
    }
}

export const sendUserOffline = async (userId: number): Promise<any> => {
    try {
        const response: ApiResponse<any> = (await apiClient.post(`/users/${userId}/send_offline`)).data;
        return response.data;
    }
    catch (error: any) {
        if (error.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }
        throw new Error('Failed to send user offline');
    }
}